import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="your_location" clip-path="url(#clip0_1426_4906)">
        <path
          id="Vector"
          d="M14.2595 17.0128L14.9775 15.4819L17.8708 9.33656C18.1364 8.70406 18.2657 7.98531 18.2441 7.27375L18.2226 6.73468H18.2513C18.2226 6.08781 18.0934 5.45531 17.8564 4.85156C17.5621 4.0825 17.1241 3.39968 16.557 2.81031C15.9898 2.22093 15.3149 1.76093 14.5611 1.4375C13.8072 1.11406 13.0103 0.955933 12.1918 0.955933C11.3734 0.955933 10.5764 1.12125 9.82259 1.4375C9.06874 1.75375 8.40105 2.22093 7.82669 2.81031C7.25951 3.39968 6.82156 4.08968 6.5272 4.85156C6.23284 5.62062 6.10361 6.42562 6.13233 7.23781C6.10361 7.98531 6.24002 8.70406 6.51284 9.35093L9.40618 15.4891L10.1313 17.02L11.2011 19.2912C11.2872 19.4853 11.4236 19.6362 11.5959 19.7369C11.9693 19.9597 12.4287 19.9525 12.7877 19.7369C12.9672 19.6291 13.1108 19.4781 13.197 19.2912L14.2667 17.0128H14.2595Z"
          fill="#5586D4"
        />
        <path
          id="Vector_2"
          d="M14.9703 8.84061C14.7262 9.30061 14.3744 9.68874 13.9436 9.97624C13.5129 10.2637 13.0175 10.4434 12.5005 10.4937C11.9836 10.544 11.4667 10.465 10.9857 10.2709C10.5046 10.0697 10.0811 9.76061 9.75798 9.35811C9.4288 8.95702 9.20429 8.48035 9.10464 7.97092C9.00486 7.46187 9.03198 6.93604 9.18362 6.43999C9.33527 5.9434 9.60647 5.49173 9.97336 5.12467C10.4141 4.68399 10.9769 4.38601 11.5888 4.26936C12.1987 4.14815 12.8308 4.21068 13.4052 4.44905C13.9795 4.68624 14.4677 5.08874 14.8195 5.60624C15.1641 6.12374 15.3508 6.73467 15.3508 7.3528C15.3508 7.8703 15.2216 8.38061 14.9775 8.84061H14.9703Z"
          fill="white"
        />
        <path
          id="Vector_3"
          d="M16.0902 15.5681L15.3723 17.0919C18.9333 17.365 21.482 18.0981 21.482 18.9606C21.482 20.0603 17.3466 20.9515 12.2492 20.9515H12.1917C7.1302 20.9444 3.03071 20.0531 3.03071 18.9606C3.03071 18.1053 5.52199 17.3865 9.01841 17.099L8.30046 15.5753C4.87584 15.8915 1.46558 16.7612 1.46558 18.9534C1.46558 22.044 8.22866 22.504 12.2564 22.504C16.2841 22.504 23.0471 22.044 23.0471 18.9534C23.0471 16.7325 19.5579 15.87 16.0974 15.5609L16.0902 15.5681Z"
          fill="#1F3E74"
        />
      </g>
      <defs>
        <clipPath id="clip0_1426_4906">
          <rect width="22.9744" height="23" fill="white" transform="translate(0.726074)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
